import { render, staticRenderFns } from "./PanoCom.vue?vue&type=template&id=c0871a04&scoped=true"
import script from "./PanoCom.vue?vue&type=script&lang=js"
export * from "./PanoCom.vue?vue&type=script&lang=js"
import style0 from "./PanoCom.vue?vue&type=style&index=0&id=c0871a04&prod&lang=less&scoped=true"
import style1 from "./PanoCom.vue?vue&type=style&index=1&id=c0871a04&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0871a04",
  null
  
)

export default component.exports